var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWidgetQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.56506 17.7374C0.709494 17.7374 0 17.0279 0 16.1723V10.9554C0 4.90386 4.92473 0 10.9554 0H16.1723C17.0279 0 17.7374 0.709494 17.7374 1.56506C17.7374 2.42063 17.0279 3.13012 16.1723 3.13012H10.9554C6.63586 3.13012 3.13012 6.63586 3.13012 10.9554V16.1723C3.13012 17.0279 2.42063 17.7374 1.56506 17.7374Z",
    fill: "#733FD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3002 17.7374C42.4447 17.7374 41.7352 17.0279 41.7352 16.1723V10.9554C41.7352 6.63586 38.2294 3.13012 33.9099 3.13012H28.693C27.8374 3.13012 27.1279 2.42063 27.1279 1.56506C27.1279 0.709494 27.8374 0 28.693 0H33.9099C39.9406 0 44.8653 4.90386 44.8653 10.9554V16.1723C44.8653 17.0279 44.1558 17.7374 43.3002 17.7374Z",
    fill: "#37D2E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.91 44.8651H30.7799C29.9243 44.8651 29.2148 44.1556 29.2148 43.3C29.2148 42.4445 29.9243 41.735 30.7799 41.735H33.91C38.2296 41.735 41.7353 38.2292 41.7353 33.9097V30.7795C41.7353 29.924 42.4448 29.2145 43.3004 29.2145C44.156 29.2145 44.8655 29.924 44.8655 30.7795V33.9097C44.8655 39.9612 39.9407 44.8651 33.91 44.8651Z",
    fill: "#733FD7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1723 44.8651H10.9554C4.92473 44.8651 0 39.9612 0 33.9097V28.6928C0 27.8372 0.709494 27.1277 1.56506 27.1277C2.42063 27.1277 3.13012 27.8372 3.13012 28.6928V33.9097C3.13012 38.2292 6.63586 41.735 10.9554 41.735H16.1723C17.0279 41.735 17.7374 42.4445 17.7374 43.3C17.7374 44.1556 17.0279 44.8651 16.1723 44.8651Z",
    fill: "#37D2E9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.4521,
    y: 9.3717,
    width: 12.0801,
    height: 12.0801,
    rx: 3,
    transform: "rotate(90 21.4521 9.3717)",
    fill: "#37D2E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.833,
    y: 9.37167,
    width: 7.47817,
    height: 7.47817,
    rx: 2,
    transform: "rotate(90 35.833 9.37167)",
    fill: "#AFEDF6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.8496,
    y: 28.3548,
    width: 7.47817,
    height: 7.47817,
    rx: 2,
    transform: "rotate(90 16.8496 28.3548)",
    fill: "#AFEDF6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.833,
    y: 23.7528,
    width: 12.0801,
    height: 12.0801,
    rx: 3,
    transform: "rotate(90 35.833 23.7528)",
    fill: "#37D2E9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetQrCode);
export default __webpack_public_path__ + "static/media/WIDGET_QR_CODE.c54d9ca52b5ac86582b68e2e39a6412e.svg";
export { ForwardRef as ReactComponent };